import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ChipSelectorButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected?: boolean }>(({ theme, selected }) => ({
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  border: `1.5px solid ${selected ? theme.palette.primary.main : theme.palette.divider}`,
  color: selected ? theme.palette.primary.main : theme.palette.text.primary,
  fontSize: theme.typography.body2.fontSize,
  lineHeight: theme.typography.body2.lineHeight,
  minWidth: 52,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.background.paper,
  flex: 1,
  '&.Mui-disabled': {
    opacity: 0.5,
  },
}));
